import { Suspense, lazy } from "react";
import { type RouteObject } from "react-router";

import type { DashboardMailboxesDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_MAILBOXES_DETAILS_LOADER } from "@application/loaders/dashboard_mailboxes_details_loader";
import { DASHBOARD_MAILBOXES_FORM_LOADER } from "@application/loaders/dashboard_mailboxes_form_loader";
import { DASHBOARD_MAILBOXES_LIST_LOADER } from "@application/loaders/dashboard_mailboxes_list_loader";

import { DASHBOARD_MAILBOXES_LINK } from "@application/navigation/dashboard_mailboxes_link";

import { Loader } from "@styled/loader";

const DashboardMailboxesDetails = lazy(() =>
  import("./mailboxes_details").then((m) => ({
    default: m.DashboardMailboxesDetails,
  })),
);
const DashboardMailboxesEdit = lazy(() =>
  import("./mailboxes_edit").then((m) => ({
    default: m.DashboardMailboxesEdit,
  })),
);
const DashboardMailboxesList = lazy(() =>
  import("./mailboxes_list").then((m) => ({
    default: m.DashboardMailboxesList,
  })),
);
const DashboardMailboxesNew = lazy(() =>
  import("./mailboxes_new").then((m) => ({ default: m.DashboardMailboxesNew })),
);

export const DASHBOARD_TRIGGERS_MAILBOXES_ROUTE = {
  path: "mailboxes",
  handle: DASHBOARD_MAILBOXES_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardMailboxesList />
        </Suspense>
      ),
      loader: DASHBOARD_MAILBOXES_LIST_LOADER,
    },
    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardMailboxesNew />
        </Suspense>
      ),
      handle: {
        name: "New",
        to: "/dashboard/triggers/mailboxes/new",
        loader: DASHBOARD_MAILBOXES_FORM_LOADER,
      },
    },
    {
      path: ":id",
      loader: DASHBOARD_MAILBOXES_DETAILS_LOADER,
      handle: (data: DashboardMailboxesDetailsQuery): Breadcrumb => ({
        name: data.mailbox.description,
        to: `/dashboard/triggers/mailboxes/${data.mailbox.id}`,
      }),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardMailboxesDetails />
            </Suspense>
          ),
        },
        {
          path: "edit",
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardMailboxesEdit />
            </Suspense>
          ),
          handle: { name: "Edit" },
          loader: DASHBOARD_MAILBOXES_FORM_LOADER,
        },
      ],
    },
  ],
} satisfies RouteObject;
